import { cssRule } from "typestyle";

cssRule("html, body, .root", {
  width: "100%",
  height: "100%",
  padding: "0",
  margin: "0",
  background: "#f0f1f6",
  fontFamily: "Roboto, Arial, sans-serif",
});
cssRule("*", {
  boxSizing: "border-box",
  margin: 0,
  padding: 0,
  outline: "none",
});

cssRule("@keyframes fadeOut", {
  // @ts-ignore fixme, non semantic. should use keyframes
  "0%": { opacity: 1 },
  "100%": { opacity: 0 },
});
